import { Component, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { filter, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-bottom-nav',
  templateUrl: './bottom-nav.component.html',
  styleUrls: ['./bottom-nav.component.scss'],
})
export class BottomNavComponent implements OnInit {

  activePage = 'home';
  subscription: Subscription;

  constructor(
    private router: Router
  ) { }

  ngOnInit() {
    this.subscription = this.router.events
    .pipe(
      filter(event => event instanceof NavigationEnd),
      startWith({url: this.router.url}),
    ).subscribe((event: NavigationEnd) => {
      const currentEndpoint = event.url.split('/')[2];
      this.activePage = currentEndpoint;
    });
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  navigateTo(url: string) {
    this.router.navigateByUrl(url);
  }

  isActive(page: string) {
    return this.activePage === page ? 'active' : '';
  }

}
